import { AgFrameworkComponent } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';

import { DataGridActionRendererParams } from './data-grid-action-renderer-params';
import { DataGridAction } from '@ideapa/app-common';

@Component({
  standalone: false,
  template: `
    <div class="d-flex h-100 align-items-center grid-action-container">
      @for (action of actions; track action) {
        <ideapa-icon-button
          [icon]="action.icon"
          (clicked)="action.onAction(params.data)"
          [title]="action.description"
          [cssClasses]="action.class"
          >
        </ideapa-icon-button>
      }
    </div>
    `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

// eslint-disable-next-line @angular-eslint/component-class-suffix
export class DataGridActionRenderer
  implements AgFrameworkComponent<DataGridActionRendererParams>
{
  public params!: DataGridActionRendererParams;

  public actions: DataGridAction[] = [];

  private cd: ChangeDetectorRef = inject(ChangeDetectorRef);

  agInit(params: DataGridActionRendererParams): void {
    this.params = params;

    this.setActions();

    const actual = this.params.api.getColumn('actions')?.getActualWidth();

    const newWidth = this.actions.length * 28 + 10;

    if (!actual || newWidth > actual) {
      this.params.api.setColumnWidths([
        { key: 'actions', newWidth: this.actions.length * 28 + 10 },
      ]);
    }
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams) {
    // set value into cell again
    this.params = params;
    this.setActions();
    this.cd.detectChanges();
  }

  private setActions() {
    this.actions = this.params.context.actions.filter((a) =>
      a.visible(this.params.data)
    );
  }
}
